<template>
    <div>
		<notifications 
			position="bottom left" 
			width="100%"
			:duration="-10"
			:closeOnClick="true"
			group="mms-notifications"
			>
			<template v-slot:body="{ item, close }">
				<div v-if="!item.data?.hasLink" class="notification" :class="item.type" @click="close">
					<p class="notification-title" v-if="item.title">{{ item.title }}</p>

					<p class="notification-message">{{ item.text }}</p>

					<div v-if="item.data?.showLoader" class="notification-loader" aria-hidden="true">
						<span></span>
						<span></span>
						<span></span>
					</div>
                    <div v-else class="notification-close close-icon" @click="close">
						<img :src="getAssetPath('cross--light.svg', 'icons')">
					</div>
				</div>

				<div v-else class="notification" :class="item.type">
					<p class="notification-title" v-if="item.title">{{ item.title }}</p>

					<p class="notification-message">{{ item.text }}</p>

					<p class="notification-link" v-if="item.data?.type === 'heatmap'" @click="openHeatmap(item, close)">{{ item.data.urlText }}</p>
					<p class="notification-link" v-else-if="item.data?.hasLink && !item.data?.url" @click="switchTab(close)">{{ item.data.urlText }}</p>
					<a v-else-if="item.data?.url" :href="item.data.url">{{ item.data.urlText }}</a>

					<div v-if="item.data?.showLoader" class="notification-loader" aria-hidden="true">
						<span></span>
						<span></span>
						<span></span>
					</div>
                    <div v-else class="notification-close close-icon" @click="close">
						<img :src="getAssetPath('cross--light.svg', 'icons')">
					</div>
				</div>
			</template>
		</notifications>
    </div>
</template>

<script src="./Notifications.js"></script>